var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeavebtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6H15M3 6V12.6001C3 13.4402 3 13.86 3.16349 14.1809C3.3073 14.4632 3.5366 14.6929 3.81885 14.8367C4.1394 15 4.55925 15 5.39768 15H12.6023C13.4408 15 13.86 15 14.1805 14.8367C14.4628 14.6929 14.6929 14.4632 14.8367 14.1809C15 13.8604 15 13.4411 15 12.6027V6M3 6V5.40015C3 4.56007 3 4.13972 3.16349 3.81885C3.3073 3.5366 3.5366 3.3073 3.81885 3.16349C4.13972 3 4.56007 3 5.40015 3H6M15 6V5.39768C15 4.55925 15 4.1394 14.8367 3.81885C14.6929 3.5366 14.4628 3.3073 14.1805 3.16349C13.8597 3 13.4402 3 12.6001 3H12M6 3H12M6 3V1.5M12 3V1.5M10.875 10.5H7.125",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeavebtn);
export default __webpack_public_path__ + "static/media/leavebtn.0c629fbfb0e259d25f33e16fe9a8a3f3.svg";
export { ForwardRef as ReactComponent };